import { ApplicationState } from './store';
import { caseInitialState } from './store/case';
import configureStoreProdatex from './configureStore';
import { detailsInitialState } from './store/details';
import { loginInitialState } from './store/login';
import { networkInitialState } from './store/network/reducer';
import { sharedInitialState } from './store/shared/reducer';
import { getStorage } from './store/utils/storage/storage.manager';
import { LoginStorageModel } from './store/login/model';

const initialNavigationState = {
  destination: '',
};

export const initialState: ApplicationState = {
  login: loginInitialState,
  caseState: caseInitialState,
  network: networkInitialState,
  details: detailsInitialState,
  shared: sharedInitialState,
  navigation: initialNavigationState
};

const storageProvider = getStorage();
const storageInstance = storageProvider.getInstance(LoginStorageModel);

export const configureStoreAsync = (): Promise<ApplicationState> => {
  return new Promise((resolve) => {
    try {
      storageInstance.find((item: LoginStorageModel) => {
        if (item && item.modelGuid === 'token') {
          return true;
        }
        return false;
      }).then((userInfo) => {
        if (!userInfo) {
          resolve(initialState);
        } else {
          const updatedLoggingData = {
            ...initialState.login,
            userId: userInfo.id,
            username: userInfo.username,
            roles: userInfo.roles
          };

          const initialStateWithLoadedUser = { ...initialState, login: updatedLoggingData };
          resolve(initialStateWithLoadedUser);
        }
      }).catch((userInfoErr) => {
        resolve(initialState);
      });

    } catch (error) {
      resolve(initialState);
    }
  });
};

export const store = configureStoreProdatex(initialState);
